module.exports = __webpack_public_path__ + "assets/xiangjiao.06ca9ec6.svg";